
export default {
  name: 'ColorSwatches',
  props: {
    swatches: {
      type: Array,
      required: true,
    },
    selectedVariantName: {
      type: String,
      default: undefined,
    },
    swatchLabel: {
      type: String,
      default: undefined,
    },
    isTabletPdpView: {
      type: Boolean,
      default: false,
    },
  },
}
